import JobWorkerOfferWorkerDeclinedReason from "@/models/JobWorkerOffers/JobWorkerOfferWorkerDeclinedReason";

export default class AnonJobWorkerOfferWorkerAcceptanceReply 
{ 
	accepted = false;
	declinedReason: JobWorkerOfferWorkerDeclinedReason = JobWorkerOfferWorkerDeclinedReason.Undefined;
}